
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"39","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_909_1208)"}},[_c('path',{attrs:{"d":"M19.713 10.348a.5.5 0 01-.426 0l-6.73-3.164a.5.5 0 01-.234-.677l2.35-4.681a.5.5 0 01.448-.276h8.758a.5.5 0 01.447.276l2.35 4.68a.5.5 0 01-.233.678l-6.73 3.163z","fill":"#fff","stroke":"#fff"}}),_c('rect',{attrs:{"x":"4.5","y":"6.5","width":"30","height":"21","rx":"3.5","fill":"red","stroke":"#fff"}}),_c('path',{attrs:{"d":"M15.272 10.64h2.24L21.688 22h-2.272l-1.056-2.832h-3.968L13.352 22H11.08l4.192-11.36zm2.688 6.976l-1.568-4.688-1.632 4.688h3.2zM22.934 22V10.64h2.208V22h-2.208z","fill":"#fff"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_909_1208","x":"0","y":"1.05","width":"39","height":"34.95","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"4"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_909_1208"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_909_1208","result":"shape"}})])])])
          )
        }
      }
    